export const root = '/help';
export const askQuestion = `${root}/question`;
export const askQuestionConfirmation = `${askQuestion}/confirmation`;
